import styled from 'styled-components';
import cx from 'classnames';
import { Colors } from 'typings';

interface Props {
  backgroundColor?: string;
  space?: string | number;
  boxShadow?: boolean;
  fill?: string;
}

const IconBorder = styled('div').attrs<Props>((props) => ({
  className: cx('icon-border', props.className),
}))`
  background-color: ${(props: Props) => props.backgroundColor || 'white'};
  padding: ${(props: Props) => props.space || 'var(--s-3)'};
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: ${(props: Props) =>
    props.boxShadow ? `0px 3px 6px ${Colors.TRANSPARENT_BLACK}` : 'none'};

  svg {
    fill: ${(props: Props) => props.fill || 'currentColor'};
  }
`;

export default IconBorder;
